import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../services/api';
import { Capacitor } from '@capacitor/core';
import { NATIVE_OAUTH_REDIRECT_URI } from '../services/nativeAuth';

function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const exchangedCode = useRef<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      // Authorization codes are single-use; StrictMode runs effects twice in dev.
      if (exchangedCode.current === code) return;
      exchangedCode.current = code;
      handleOAuthCallback(code);
    } else {
      setError('No authorization code received');
    }
  }, []);

  const handleOAuthCallback = async (code: string) => {
    try {
      const redirectUri = Capacitor.isNativePlatform()
        ? NATIVE_OAUTH_REDIRECT_URI
        : `${window.location.origin}/auth/callback`;
      const response = await authApi.oauthToken(code, redirectUri);
      login(response.data.user, response.data.tokens);

      // If user has no zipcode, redirect to profile setup
      if (!response.data.user.zipcode) {
        navigate('/setup');
      } else {
        navigate('/dashboard');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Authentication failed. Please try again.');
    }
  };

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h2>Authentication Error</h2>
          <div className="alert alert-error">{error}</div>
          <button onClick={() => navigate('/')} className="btn btn-primary btn-full">
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="loading" role="status">
          <div className="loading-spinner" aria-hidden="true"></div>
          <p>Completing sign in...</p>
        </div>
      </div>
    </div>
  );
}

export default AuthCallbackPage;
